//封装页面跳转的几种方法

//router  基于路由配置，如果没有对应的路由配置参数会出错

const jump = {
    //当前页面打开
    toViewPage($this,$path,$query) {
        $this.$router.push({
            path: $path,
            query: $query
        })
    },
    //新页面打开
    toResolvePage($this,$name,$query){
        const routeData = $this.$router.resolve({
            name: $name,
            query: $query
        });
        window.open(routeData .href, '_blank');
    },
    //抛开路由表，跳转到第三方链接
    toWindowHref($url){
        window.open($url,"_blank");
    },
    //抛开路由表，跳转到第三方链接
    toWindowURL($url){
        window.open($url);
    }
}

export default jump;


// WEBPACK FOOTER //
// ./src/utils/jump.js